const auth = {
	Redirecting: "Redirecting",
	NotAuthorize:
		"You are not authorize to view this page.\n\nYou should be redirect to the login page soon.",
	Error: "Error during authentication"
};

export default auth;
